import { supabase, Notificacion } from '../lib/supabase';

export const notificacionesService = {
  async getByUsuario(usuarioId: string, limit = 20): Promise<Notificacion[]> {
    const { data, error } = await supabase
      .from('notificaciones')
      .select('*')
      .eq('usuario_id', usuarioId)
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return data || [];
  },

  async contarNoLeidas(usuarioId: string): Promise<number> {
    const { count, error } = await supabase
      .from('notificaciones')
      .select('*', { count: 'exact', head: true })
      .eq('usuario_id', usuarioId)
      .eq('leida', false);

    if (error) throw error;
    return count || 0;
  },

  async marcarLeida(id: string): Promise<void> {
    const { error } = await supabase
      .from('notificaciones')
      .update({ leida: true })
      .eq('id', id);

    if (error) throw error;
  },

  async marcarTodasLeidas(usuarioId: string): Promise<void> {
    const { error } = await supabase
      .from('notificaciones')
      .update({ leida: true })
      .eq('usuario_id', usuarioId)
      .eq('leida', false);

    if (error) throw error;
  },

  async crear(notificacion: Omit<Notificacion, 'id' | 'created_at' | 'leida'>): Promise<void> {
    // La política RLS solo permite service_role para INSERT directo en notificaciones.
    // Se usa la función SECURITY DEFINER que valida rol de admin antes de insertar.
    const { error } = await supabase.rpc('crear_notificacion_sistema', {
      p_usuario_id: notificacion.usuario_id,
      p_tipo: notificacion.tipo,
      p_titulo: notificacion.titulo,
      p_cuerpo: notificacion.cuerpo ?? null,
      p_referencia_id: notificacion.referencia_id ?? null,
      p_referencia_tipo: notificacion.referencia_tipo ?? null,
    });
    if (error) throw error;
  },

  async eliminar(id: string): Promise<void> {
    const { error } = await supabase
      .from('notificaciones')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },
};
